import PropTypes from 'prop-types';
import { ContentTitle } from '../../components/typography/Heading';
import styles from './organization-header.module.less';
import OrganizationCta from '../organization-show/organization-cta/OrganizationCta';
import EditOrganizationDescriptionImage from '../organization-show/organization-image/EditOrganizationDescriptionImage';
import EditOrganizationImage from '../edit-organization-image/EditOrganizationImage';
import OrganizationLead from './OrganizationLead';
import { WHITE_ORGANIZATION_COLOR } from '../theme/OrganizationTheme';

const OrganizationHeader = ({
    organization,
    displayCta = true,
    displayLead = true,
    displayImage = true,
    editable = false,
}) => {
    return (
        <header>
            {displayImage && (
                <div className={styles.topImageContainer}>
                    <div className={styles.topImage}>
                        <EditOrganizationDescriptionImage organization={organization} editable={editable} />
                    </div>
                </div>
            )}
            <ContentTitle tag="h1" className={[styles.imageAndTitleWrapper, WHITE_ORGANIZATION_COLOR].join(' ')}>
                <EditOrganizationImage
                    organizationId={organization.id}
                    alt={`Logoen til ${organization.name}`}
                    editable={editable}
                />
                <span className={styles.headerTitle}>{organization.name}</span>
            </ContentTitle>
            {displayLead && <OrganizationLead organization={organization} editable={editable} />}
            {displayCta && <OrganizationCta id={organization.id} />}
        </header>
    );
};

OrganizationHeader.propTypes = {
    organization: PropTypes.object.isRequired,
};

export default OrganizationHeader;
